import type { TargetFunction } from '../../store/reducers/workspace.reducer';
import type { MeasurementVisualizationType } from '../../types/view';

/** Photometry keys used in REPORT_IMAGE filenames (backend + frontend). */
export type PdfPhotometryType =
  | 'luminance'
  | 'horizontal_illuminance'
  | 'vertical_illuminance'
  | 'semicylindrical_illuminance'
  | 'hemispherical_illuminance';

/** Each photometry with its viewer mode, measurement field and the target function it reports. */
export const PDF_PHOTOMETRY_ENTRIES: ReadonlyArray<{
  photometry: PdfPhotometryType;
  visualization: MeasurementVisualizationType;
  fieldIndex: number;
  targetFn: TargetFunction;
}> = [
  { photometry: 'luminance', visualization: 'luminance', fieldIndex: 0, targetFn: 'L' },
  { photometry: 'horizontal_illuminance', visualization: 'horizontalIlluminance', fieldIndex: 1, targetFn: 'E' },
  { photometry: 'vertical_illuminance', visualization: 'verticalIlluminance', fieldIndex: 2, targetFn: 'Ev' },
  {
    photometry: 'semicylindrical_illuminance',
    visualization: 'semiCylindricalIlluminance',
    fieldIndex: 3,
    targetFn: 'Esc',
  },
  {
    photometry: 'hemispherical_illuminance',
    visualization: 'hemisphericalIlluminance',
    fieldIndex: 4,
    targetFn: 'Ehs',
  },
];

/** Photometries chosen for the PDF; a missing entry counts as included. */
export type PhotometrySelection = Partial<Record<PdfPhotometryType, boolean>>;

export const isPhotometryIncluded = (selection: PhotometrySelection | undefined, photometry: string): boolean =>
  selection?.[photometry as PdfPhotometryType] !== false;

type PdfGraphType = 'false_color' | 'isocontour';

export const makeReportImageKey = (layerUuid: string, graphType: PdfGraphType | 'ldc', photometry: string): string =>
  `${layerUuid}__${graphType}__${photometry}`;
